// extracted by mini-css-extract-plugin
module.exports = {"main-component":"training_main-component__3v66i"};